<template>
  <v-dialog
    :value="isModalVisible"
    persistent
    max-width="690"
    @input="onDialogInput"
  >
    <v-card class="vc-modal">
      <v-card-title class="vc-modal__header">
        <span class="vc-modal__title">{{ $t('message.sichernConnect.modal.title') }}</span>
        <v-btn icon flat class="vc-modal__close" :disabled="isBusy" @click="closeModal">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="vc-modal__body pa-0">
        <sichern-connect-body v-if="flowHasEmail" />
        <sichern-connect-no-email-body v-else />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import SichernConnectBody from './SichernConnectBody.vue'
import SichernConnectNoEmailBody from './SichernConnectNoEmailBody.vue'

export default {
  name: 'SichernConnect',
  components: { SichernConnectBody, SichernConnectNoEmailBody },
  provide () {
    return {
      connection: {
        applyLinkAccount: this.applyLinkAccount,
        closeModal: this.closeModal,
        rememberMeLater: this.rememberMeLater
      }
    }
  },
  data () {
    return {
      isLoading: false
    }
  },
  computed: {
    isModalVisible () {
      return this.$store.state.sichernConnect.isModalVisible
    },
    flowHasEmail () {
      return this.$store.getters['sichernConnect/hasEmailFlow'] && this.$store.state.profile.mail
    },
    isRequestLoading () {
      return this.$store.state.sichernConnect.isRequestLoading
    },
    isBusy () {
      return this.isLoading || this.isRequestLoading
    }
  },
  methods: {
    onDialogInput (value) {
      if (!value) this.closeModal()
    },
    closeModal () {
      if (this.isBusy) return
      this.$store.dispatch('sichernConnect/clearApiErrors')
      this.$store.commit('sichernConnect/SET_MODAL_VISIBLE', false)
    },
    rememberMeLater () {
      if (this.isBusy) return
      this.$store.dispatch('sichernConnect/cancelLinking')
    },
    async applyLinkAccount () {
      try {
        this.isLoading = true
        await this.$store.dispatch('sichernConnect/setLinkAccount')
      } catch (error) {
        console.error(error)
        this.$store.commit('sichernConnect/SET_MODAL_VISIBLE', false)
        throw error
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
.vc-modal {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 11px 15px -7px rgba(0,0,0,.2), 0 24px 38px 3px rgba(0,0,0,.14), 0 9px 46px 8px rgba(0,0,0,.12) !important;

  &__header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 1.5rem 1.5rem 0 1.5rem !important;
    background: white;
  }

  &__title {
    color: #171717;
    font-size: 1.5rem;
    font-weight: 500;
    line-height: 1.5;
  }

  &__close {
    margin: 0;
    color: #171717;
  }

  &__body {
    background: white;
  }
}
</style>

<style lang="scss">
.v-dialog__content--active {
  background-color: rgba(16, 24, 40, 0.5);
}
</style>
